export default __webpack_public_path__ + "static/media/tarun-javeli.2dab0543.jpeg";